export const actionOptions = {
  "actions": [
    {
      title: "FixIt Order",
      cls: "fixit-order",
      icon: "hourglass",
      disabled:true
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/fixitOrders/filter/actionOptions.js